// Reference: https://gist.github.com/Godofbrowser/bf118322301af3fc334437c683887c5f
import api from "api"
import { AuthManager } from "utils/AuthManager"

let isTokenRefreshing = false

const promises: ((value: boolean) => void)[] = []

const forceLogin = () => {
  AuthManager.clearAuthInfo()
  AuthManager.redirectToLogin()
}

export async function refreshToken(): Promise<boolean> {
  const authInfo = AuthManager.getAuthInfo()
  if (!authInfo) {
    forceLogin()
    return false
  }

  if (isTokenRefreshing) {
    // Create a promise that will be resolved when the refresh completes
    const currentRequestPromise = new Promise<boolean>(resolve => {
      promises.push(resolve)
    })

    // Wait for the refresh token to complete
    return await currentRequestPromise
  }

  isTokenRefreshing = true

  let refreshed = false
  try {
    const refreshToken = authInfo.refreshToken

    if (!refreshToken) throw new Error("User is already logged out")
    const res = await api.auth.refreshToken({
      data: {
        refreshToken,
      },
      headers: {
        Authorization: null,
      },
    })

    const newAuthInfo = {
      ...authInfo,
      accessToken: res.accessToken,
      refreshToken: res.refreshToken,
    }
    AuthManager.saveAuthInfo(newAuthInfo)
    refreshed = true
  } catch (e) {
    console.info("> Refresh token expired. Logging out.")
  }

  // Resolve all queued promises with the refresh result
  isTokenRefreshing = false
  promises.splice(0).forEach(resolve => {
    resolve(refreshed)
  })

  if (!refreshed) {
    forceLogin()
  }

  return refreshed
}
